"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* tslint:disable */
var node = {
  "kind": "Fragment",
  "name": "ArtworkFilter_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [{
    "kind": "LocalArgument",
    "name": "acquireable",
    "type": "Boolean",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "aggregations",
    "type": "[ArtworkAggregation]",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "artist_id",
    "type": "String",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "at_auction",
    "type": "Boolean",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "attribution_class",
    "type": "[String]",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "color",
    "type": "String",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "for_sale",
    "type": "Boolean",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "height",
    "type": "String",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "inquireable_only",
    "type": "Boolean",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "keyword",
    "type": "String",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "major_periods",
    "type": "[String]",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "medium",
    "type": "String",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "offerable",
    "type": "Boolean",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "page",
    "type": "Int",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "partner_id",
    "type": "ID",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "price_range",
    "type": "String",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "sort",
    "type": "String",
    "defaultValue": "-partner_updated_at"
  }, {
    "kind": "LocalArgument",
    "name": "width",
    "type": "String",
    "defaultValue": null
  }],
  "selections": [{
    "kind": "LinkedField",
    "alias": "filtered_artworks",
    "name": "filter_artworks",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "acquireable",
      "variableName": "acquireable",
      "type": "Boolean"
    }, {
      "kind": "Variable",
      "name": "aggregations",
      "variableName": "aggregations",
      "type": "[ArtworkAggregation]"
    }, {
      "kind": "Variable",
      "name": "artist_id",
      "variableName": "artist_id",
      "type": "String"
    }, {
      "kind": "Variable",
      "name": "at_auction",
      "variableName": "at_auction",
      "type": "Boolean"
    }, {
      "kind": "Variable",
      "name": "attribution_class",
      "variableName": "attribution_class",
      "type": "[String]"
    }, {
      "kind": "Variable",
      "name": "color",
      "variableName": "color",
      "type": "String"
    }, {
      "kind": "Variable",
      "name": "for_sale",
      "variableName": "for_sale",
      "type": "Boolean"
    }, {
      "kind": "Variable",
      "name": "height",
      "variableName": "height",
      "type": "String"
    }, {
      "kind": "Variable",
      "name": "inquireable_only",
      "variableName": "inquireable_only",
      "type": "Boolean"
    }, {
      "kind": "Variable",
      "name": "keyword",
      "variableName": "keyword",
      "type": "String"
    }, {
      "kind": "Variable",
      "name": "major_periods",
      "variableName": "major_periods",
      "type": "[String]"
    }, {
      "kind": "Variable",
      "name": "medium",
      "variableName": "medium",
      "type": "String"
    }, {
      "kind": "Variable",
      "name": "offerable",
      "variableName": "offerable",
      "type": "Boolean"
    }, {
      "kind": "Variable",
      "name": "page",
      "variableName": "page",
      "type": "Int"
    }, {
      "kind": "Variable",
      "name": "partner_id",
      "variableName": "partner_id",
      "type": "ID"
    }, {
      "kind": "Variable",
      "name": "price_range",
      "variableName": "price_range",
      "type": "String"
    }, {
      "kind": "Literal",
      "name": "size",
      "value": 0,
      "type": "Int"
    }, {
      "kind": "Variable",
      "name": "sort",
      "variableName": "sort",
      "type": "String"
    }, {
      "kind": "Variable",
      "name": "width",
      "variableName": "width",
      "type": "String"
    }],
    "concreteType": "FilterArtworks",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "__id",
      "args": null,
      "storageKey": null
    }, {
      "kind": "FragmentSpread",
      "name": "ArtworkFilterArtworkGrid2_filtered_artworks",
      "args": null
    }]
  }]
};
node.hash = 'b03297e790c78632c4fe24bd5d7de6e3';
var _default = node;
exports.default = _default;
//# sourceMappingURL=ArtworkFilter_viewer.graphql.js.map